var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeywords({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4705,
    cy: 4.8992,
    r: 2.6492,
    stroke: "#373F50",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7154 14.0871L11.9677 14.1447L11.8551 15.6405L12.6029 15.5828L12.7154 14.0871ZM13.1014 15.5444C13.5144 15.5126 13.8744 15.152 13.9055 14.7389C13.9366 14.3259 13.627 14.0168 13.214 14.0487L13.1014 15.5444ZM12.6029 15.5828L13.1014 15.5444L13.214 14.0487L12.7154 14.0871L12.6029 15.5828Z",
    fill: "#373F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7565 11.7306L12.0087 11.7882L11.8961 13.284L12.6439 13.2264L12.7565 11.7306ZM13.4416 13.1649C13.8546 13.1331 14.2145 12.7725 14.2456 12.3595C14.2767 11.9464 13.9671 11.6374 13.5541 11.6692L13.4416 13.1649ZM12.6439 13.2264L13.4416 13.1649L13.5541 11.6692L12.7565 11.7306L12.6439 13.2264Z",
    fill: "#373F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.686 8.09375L11.7452 16.0935",
    stroke: "#373F50",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywords);
export default __webpack_public_path__ + "static/media/keywords.7a2ab47af34aeb87cd391f8ef86f195d.svg";
export { ForwardRef as ReactComponent };